import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid } from 'recharts';
import { ChartCard, ChartEmpty } from './ChartCard';

interface Point { time: string; price: number; }
interface Props { sp500: Point[]; nasdaq: Point[]; dow: Point[]; }

/** 정수 + 천단위 콤마 (Y축/툴팁 공통) */
const fmtIndex = (v: number) => Math.round(v).toLocaleString('en-US');

function MiniLine({ data, color }: { data: Point[]; color: string }) {
  if (data.length === 0) return <ChartEmpty />;
  // 79개 5분봉 → 약 6개 라벨만 노출 (혼잡 방지)
  const labelInterval = Math.max(1, Math.ceil(data.length / 6));
  return (
    <ResponsiveContainer width="100%" height={220}>
      <LineChart data={data} margin={{ top: 6, right: 12, left: 0, bottom: 0 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="var(--color-border)" />
        <XAxis
          dataKey="time"
          tick={{ fontSize: 10 }}
          interval={labelInterval}
        />
        <YAxis
          domain={['auto', 'auto']}
          allowDataOverflow={false}
          tick={{ fontSize: 11 }}
          tickFormatter={fmtIndex}
          width={80}
        />
        <Tooltip
          formatter={(value: number) => [fmtIndex(value), '지수']}
          labelFormatter={(label: string) => `시간 ${label}`}
        />
        <Line type="monotone" dataKey="price" stroke={color} strokeWidth={2} dot={false} />
      </LineChart>
    </ResponsiveContainer>
  );
}

/** 미장 마감 — S&P500 / NASDAQ / Dow 당일 분봉 */
export function UsCloseChart({ sp500, nasdaq, dow }: Props) {
  return (
    <div className="grid gap-4 md:grid-cols-3">
      <ChartCard title="S&P 500" subtitle="당일 5분봉">
        <MiniLine data={sp500} color="#0d9488" />
      </ChartCard>
      <ChartCard title="NASDAQ" subtitle="당일 5분봉">
        <MiniLine data={nasdaq} color="#0284c7" />
      </ChartCard>
      <ChartCard title="Dow Jones" subtitle="당일 5분봉">
        <MiniLine data={dow} color="#6366f1" />
      </ChartCard>
    </div>
  );
}
